import React, { useState } from 'react';
import Box from 'Components/Atoms/Box';
import Typography from 'Components/Atoms/Typography';
import Button from 'Components/Atoms/Button';
import Modal from 'Components/Molecules/Modal';
import './styles.scss';

const CALENDAR_URL = 'https://calendar.app.google/Y45KELG5LouWkZvH6';
const TEST_PHONE_NUMBER = '+4962217239169';
const TEST_PHONE_NUMBER_DISPLAY = '+49 6221 7239169';

type Scenario = {
  title: string;
  description: string;
  example?: string;
};

const SCENARIOS: Scenario[] = [
  {
    title: '🐕 Eine Frage stellen',
    description:
      'Frage Sia, ob du deinen Hund mitbringen darfst – oder stelle jede andere Frage zum Restaurant.',
    example: '„Kann ich meinen Hund mitbringen?"',
  },
  {
    title: '🥂 Nach einer geschlossenen Gesellschaft fragen',
    description:
      'Frage, ob man das Restaurant auch für eine geschlossene Gesellschaft buchen kann.',
    example:
      '„Kann ich das Restaurant auch für eine geschlossene Gesellschaft buchen?"',
  },
  {
    title: '📅 Eine neue Reservierung machen',
    description:
      'Buche eine Reservierung wie ein echter Gast – Sia fragt nach Datum, Uhrzeit, Personenzahl und Name.',
  },
  {
    title: '✏️ Reservierung stornieren oder ändern',
    description:
      'Ruf direkt im Anschluss noch einmal an und ändere oder storniere deine eben erstellte Reservierung.',
    example:
      '„Ich hatte gerade schon einmal angerufen und eine Reservierung gemacht. Ich musste mich leider doch umentscheiden und würde nun gerne stornieren."',
  },
];

const PhoneAssistantPromoBanner: React.FC = () => {
  const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);

  const openCalendar = () => {
    window.open(CALENDAR_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Box className="phone-promo-banner">
        <Box className="phone-promo-content">
          <Typography variant="h3" className="phone-promo-title">
            Jetzt unsere Telefonassistentin Sia 3 Monate kostenlos testen
          </Typography>
          <Typography
            variant="text-3"
            className="phone-promo-description"
            component="p"
          >
            Anrufe und Grundgebühr inklusive – ohne versteckte Kosten
            <br />
            Die neue Sia beantwortet Fragen, klingt natürlicher,
            <br />
            bearbeitet und storniert Reservierungen – und vieles mehr.
          </Typography>
          <Typography variant="text-4" className="phone-promo-footnote">
            👉 Angebot gültig für die ersten 200 Restaurants – nur für kurze
            Zeit
          </Typography>
        </Box>
        <Box className="phone-promo-actions">
          <Button variant="primary" onClick={openCalendar}>
            Jetzt Termin vereinbaren
          </Button>
          <Button
            variant="outlined"
            onClick={() => setShowLearnMoreModal(true)}
          >
            Mehr erfahren
          </Button>
        </Box>
        <img
          src="/floating_phone.png"
          alt=""
          aria-hidden
          className="phone-promo-graphic"
        />
      </Box>

      <Modal
        open={showLearnMoreModal}
        onClose={() => setShowLearnMoreModal(false)}
        maxWidth="sm"
        title="Sia jetzt selbst testen"
        actions={[
          {
            id: 'close',
            label: 'Schließen',
            onClick: () => setShowLearnMoreModal(false),
          },
          {
            id: 'book',
            label: 'Termin vereinbaren',
            variant: 'primary',
            onClick: () => {
              setShowLearnMoreModal(false);
              openCalendar();
            },
          },
        ]}
      >
        <Box className="phone-promo-modal">
          <Typography
            variant="text-3"
            className="phone-promo-modal-intro"
            block
          >
            Ruf unser Test-Restaurant an und überzeuge dich selbst:
          </Typography>

          <a
            href={`tel:${TEST_PHONE_NUMBER}`}
            className="phone-promo-modal-phone"
          >
            {TEST_PHONE_NUMBER_DISPLAY}
          </a>

          <Typography
            variant="text-4"
            className="phone-promo-modal-phone-hint"
            block
          >
            Tippe auf die Nummer, um direkt anzurufen.
          </Typography>

          <Box className="phone-promo-modal-scenarios">
            <Typography
              variant="h4"
              className="phone-promo-modal-scenarios-title"
              block
            >
              Das kannst du ausprobieren
            </Typography>

            {SCENARIOS.map((scenario, index) => (
              <Box key={scenario.title} className="phone-promo-modal-scenario">
                <Box className="phone-promo-modal-scenario-index">
                  {index + 1}
                </Box>
                <Box className="phone-promo-modal-scenario-content">
                  <Typography
                    variant="text-3"
                    weight="bold"
                    className="phone-promo-modal-scenario-title"
                    block
                  >
                    {scenario.title}
                  </Typography>
                  <Typography
                    variant="text-4"
                    className="phone-promo-modal-scenario-description"
                    block
                  >
                    {scenario.description}
                  </Typography>
                  {scenario.example && (
                    <Typography
                      variant="text-4"
                      className="phone-promo-modal-scenario-example"
                      block
                    >
                      {scenario.example}
                    </Typography>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PhoneAssistantPromoBanner;
